// src/redux/taskSlice.js
import { createSlice } from '@reduxjs/toolkit';

// Initial state
const initialState = {
  tasks: [],
};

// Create task slice
const taskSlice = createSlice({
  name: 'tasks',
  initialState,
  reducers: {
    // Add a new task
    addTask: (state, action) => {
      state.tasks.push(action.payload);
    },
    // Update an existing task
    updateTask: (state, action) => {
      const index = state.tasks.findIndex(task => task.id === action.payload.id);
      if (index !== -1) {
        state.tasks[index] = action.payload;
      }
    },
  },
});

// Export actions and reducer
export const { addTask, updateTask } = taskSlice.actions;
export default taskSlice.reducer;
